import React from 'react';
import { connect } from 'react-redux';
import HoursModal from './HoursModal';
import Hours from '../components/Hours';
import { showModal } from '../actions/modal';
import propDefs from '../proptypes';
import SeeAllHoursButton from '../components/SeeAllHoursButton';

const getApp = (department, hours, prefs, show, getModalDisplay) => {
	const classes = ['clearfix'];
	const isModal = false;
	if (prefs.showCurrentDayOnly === 'true') {
		classes.push('row');
	}

	if (hours && Object.keys(hours).length) {
		return (
			<div className={classes.join(' ')}>
				<Hours
					hours={hours}
					prefs={prefs}
					department={department}
					isModal={isModal}
				/>
				<SeeAllHoursButton showModalAction={getModalDisplay} />
				<HoursModal hours={hours} prefs={prefs} showModal={show} />
			</div>
		);
	}

	return null;
};

export class WidgetContainer extends React.Component {
	render() {
		let department = null;
		if (this.props.hours && Object.keys(this.props.hours).length) {
			const id = this.props.prefs['department.id'];
			department =
				id && this.props.hours[id]
					? id
					: Object.keys(this.props.hours)[0];
		}

		return getApp(
			department,
			this.props.hours,
			this.props.prefs,
			this.props.modal.showModal,
			this.props.getModalDisplay
		);
	}
}

WidgetContainer.defaultProps = {
	hours: propDefs.defaults.hours,
	getModalDisplay: propDefs.defaults.getModalDisplay
};

WidgetContainer.propTypes = {
	hours: propDefs.settings.hours,
	prefs: propDefs.settings.prefs.isRequired,
	modal: propDefs.settings.modal.isRequired,
	getModalDisplay: propDefs.settings.getModalDisplay
};

const mapStateToProps = state => {
	return {
		hours: state.hours,
		prefs: state.prefs,
		modal: state.modal
	};
};

const mapDispatchToProps = dispatch => ({
	getModalDisplay: () => {
		dispatch(showModal());
	}
});

const Widget = connect(
	mapStateToProps,
	mapDispatchToProps
)(WidgetContainer);

export default Widget;



// WEBPACK FOOTER //
// ./src/containers/Widget.jsx